export default function resolveComponentProps(_0x49ddaf,_0x2269eb){if(typeof _0x49ddaf==='function')return _0x49ddaf(_0x2269eb);return _0x49ddaf;}